import { render, staticRenderFns } from "./BindWiki.vue?vue&type=template&id=330f41b8&"
import script from "./BindWiki.vue?vue&type=script&lang=js&"
export * from "./BindWiki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports